import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { PricingModalTypes } from "../../../../components/modal/GatedContentModal";
import { GatedContentStatus } from "store/stripeConnectAccount/types";
import { GatedContentDisabledTooltip } from "components/tooltips/GatedContentDisabledTooltip";
import { EmptyState } from "components/empty-state/EmptyState";

interface GatedContentEmptyProps {
    updateModal: (arg0: boolean, arg1: PricingModalTypes) => void;
    isStripeConnected?: boolean;
    gatedContentStatus: GatedContentStatus;
}

export const GatedContentEmpty = ({
    updateModal,
    isStripeConnected,
    gatedContentStatus
}: GatedContentEmptyProps) => {
    const { t } = useTranslation();

    const canCreatePasses = useMemo(() => {
        return (
            gatedContentStatus ===
                GatedContentStatus.STRIPE_ACCOUNT_UNVERIFIED ||
            gatedContentStatus === GatedContentStatus.READY
        );
    }, [gatedContentStatus]);

    return (
        <div className="row">
            <EmptyState
                title={t("gated-content-page:no-pricing")}
                description={
                    !isStripeConnected &&
                    t("gated-content-page:no-pricing-body")
                }
            >
                <>
                    {isStripeConnected && (
                        <GatedContentDisabledTooltip
                            gatedContentStatus={gatedContentStatus}
                            style={{ marginTop: "1rem", marginBottom: "1rem" }}
                            labelOrientation="bottom"
                        >
                            <button
                                className="btn btn-primary"
                                type="button"
                                onClick={() =>
                                    updateModal(true, PricingModalTypes.Create)
                                }
                                disabled={!canCreatePasses}
                            >
                                {t("gated-content-page:create-btn")}
                            </button>
                        </GatedContentDisabledTooltip>
                    )}
                </>
            </EmptyState>
        </div>
    );
};
